import * as React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Chip } from '@material-ui/core';
import themes from 'styles/themes';

export interface IPrimaryChipProps {
    title: String;
    handleClick: any;
}
const useStyles = makeStyles(() => ({
    chipRoot: {
        backgroundColor: themes.palette.warning['500'],
        corlor: themes.palette.primary.main,
        marginRight: 4,
        '&:hover': {
            backgroundColor: themes.palette.warning['200'],
        },
    },
    chipLabel: {
        padding: '0 8px',
        color: themes.palette.primary.main,
        fontFamily: 'PoppinsRegular',
        fontSize: 14,
        fontWeight: 400,
    },
    chipIcon: {
        color: themes.palette.primary.main,
    },
}));
export default function PrimaryChip({ title, handleClick }: IPrimaryChipProps) {
    const classes = useStyles();
    return (
        <Chip
            classes={{
                root: classes.chipRoot,
                label: classes.chipLabel,
                icon: classes.chipIcon,
            }}
            clickable
            label={title}
            onClick={handleClick}
        />
    );
}
